import React from "react";

interface SectionProps {
  title: string;
  children: React.ReactNode;
  action?: React.ReactNode;
}

const Section: React.FC<SectionProps> = ({ title, children, action }) => {
  return (
    <div>
      <div className="mt-10 flex items-center justify-between">
        <h2 className="text-md font-semibold text-gray-400">{title}</h2>
        {action}
      </div>
      <div className="mt-4">{children}</div>
    </div>
  );
};

export default Section;
